var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['button', 'is-outlined', _vm.isFullWidth, _vm.isLoading],domProps:{"innerHTML":_vm._s(_vm.text || _vm.hasIcon)},on:{"click":_vm.event}})}
var staticRenderFns = []

export { render, staticRenderFns }